import { Alert, Progress, Space, Typography } from 'antd';

import { describeHeartbeat, describeProgress, KIND_LABELS, percentOf } from './shared';

const { Text } = Typography;

/*
 * Bandeau de suivi, affiché en haut de la page pendant qu'une opération tourne : ce qu'elle
 * fait, où elle en est, et si le serveur donne encore signe de vie.
 */
const JobStatus = ({ job, now, stalled }) => (
  <Space
    direction="vertical"
    size="small"
    style={{ backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: 5, padding: 15, width: '100%' }}>
    <Space split="·" wrap>
      <Text strong>{KIND_LABELS[job.kind] || 'Opération'}</Text>
      <Text type="secondary">{job.dryRun ? 'simulation' : 'exécution'}</Text>
      {job.platforms && job.platforms.length > 0 && <Text type="secondary">{job.platforms.join(', ')}</Text>}
    </Space>

    <Progress percent={percentOf(job.progress)} status={stalled ? 'exception' : 'active'} />

    <Space split="·" wrap>
      <Text>{describeProgress(job.progress)}</Text>
      {job.progress && job.progress.batches > 0 && <Text type="secondary">{job.progress.batches} lots</Text>}
      <Text type={stalled ? 'danger' : 'secondary'}>{describeHeartbeat(job, now)}</Text>
    </Space>

    {stalled && (
      <Alert
        type="warning"
        showIcon
        message="Plus de signe de vie du serveur depuis 45 secondes"
        description={
          'Le process qui traitait l’opération ne répond plus. Son verrou expire au bout de 5 minutes, après quoi elle sera ' +
          'marquée interrompue. Ce qui a déjà été validé en base est acquis : relancer une simulation pour voir où en est ' +
          'la reprise.'
        }
      />
    )}
  </Space>
);

export default JobStatus;
